import React, { createContext, useContext, PropsWithChildren } from 'react'
import { EntityUnionType } from 'common/types/entities/EntityInterface'

type CreateEntityElementType = (
  entity: EntityUnionType,
  additionalProps?: Record<string, any>,
) => JSX.Element

interface CreateEntitiesContextInterface {
  createEntityElement: CreateEntityElementType
}

const CreateEntityElementContext =
  createContext<CreateEntitiesContextInterface | null>(null)

export const useCreateEntityElement = () => {
  const createEntityElementContext = useContext(CreateEntityElementContext)
  if (!createEntityElementContext) {
    throw new Error(
      'useCreateEntity must be used within a CreateEntitiesProvider',
    )
  }

  return createEntityElementContext.createEntityElement
}

export function CreateEntityElementProvider({
  createEntityElement,
  children,
}: PropsWithChildren<CreateEntitiesContextInterface>) {
  return (
    <CreateEntityElementContext.Provider value={{ createEntityElement }}>
      {children}
    </CreateEntityElementContext.Provider>
  )
}
